import { useEffect, useState, useRef } from "react";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Manifesto from "@/components/site/Manifesto";
import About from "@/components/site/About";
import ServicesWork from "@/components/site/ServicesWork";
import Ebook from "@/components/site/Ebook";
import FAQ from "@/components/site/FAQ";
import Blog from "@/components/site/Blog";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import AdWelcome from "@/components/site/AdWelcome";
import BookingModal from "@/components/site/BookingModal";
import "@/App.css";

function App() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    function loop(time) { lenis.raf(time); raf = requestAnimationFrame(loop); }
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);

  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el && lenisRef.current) lenisRef.current.scrollTo(el, { offset: -96 });
    else if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const openConsult = () => scrollTo("#services-work");

  const openService = (key) => {
    if (key === "ebook") { scrollTo("#ebook-section"); return; }
    scrollTo("#services-work");
    setTimeout(() => window.dispatchEvent(new CustomEvent("ma:open-service", { detail: key })), 350);
  };

  // Deep links for Instagram/ads: ?service=consultation | transformation | ebook
  // Bare ad links (?utm_source=instagram) get a tap-friendly welcome strip instead.
  const [showAdWelcome] = useState(() => {
    const p = new URLSearchParams(window.location.search);
    return Boolean(p.get("utm_source")) && !p.get("service");
  });
  useEffect(() => {
    const s = new URLSearchParams(window.location.search).get("service");
    if (s === "consultation" || s === "transformation") {
      setTimeout(() => {
        scrollTo("#services-work");
        window.dispatchEvent(new CustomEvent("ma:open-service", { detail: s }));
      }, 800);
    } else if (s === "ebook") {
      setTimeout(() => scrollTo("#ebook-section"), 800);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="App">
      <div className="grain min-h-screen bg-[#FAF7F0]" data-testid="app-root">
        <Navbar onBook={openConsult} onNav={scrollTo} />
        <main>
          <Hero onBook={() => setBookingOpen(true)} onConsult={() => scrollTo("#services-work")} onNav={scrollTo} />
          <Manifesto />
          <About onBook={openConsult} />
          <ServicesWork />
          <Ebook />
          <FAQ />
          <Blog onWorkWithMe={() => scrollTo("#services-work")} />
          <Contact />
        </main>
        <Footer onNav={scrollTo} onBook={openConsult} />
        {showAdWelcome && <AdWelcome onSelect={openService} />}
        <BookingModal open={bookingOpen} onOpenChange={setBookingOpen} prefillPlan={null} />
      </div>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
